// extracted by mini-css-extract-plugin
export default {"variableIconWrapper":"WhiteLabeling_variableIconWrapper__deXuA","footerAlign":"WhiteLabeling_footerAlign__mQgFf"};